import { SVGProps, Ref, forwardRef } from 'react';

export const ClickmeSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M11.01 11.454c-.113-.643.64-1.078 1.14-.658l6.304 5.293a.7.7 0 0 1-.345 1.228l-1.76.267 2.607 4.515-1.56.9-2.606-4.515-1.111 1.391a.7.7 0 0 1-1.237-.315z"
            fill="currentColor"
        />
        <path
            d="M12.383 1.004c7.7.162 10.443 5.243 10.61 10.48L23 12h-1.8c0-2.483-.624-4.772-1.99-6.41C17.895 4.01 15.693 2.8 12 2.8S6.106 4.01 4.79 5.59C3.423 7.228 2.8 9.517 2.8 12s.624 4.772 1.99 6.41a7 7 0 0 0 2.436 1.86l-.905 1.565C2.431 19.931 1 15.966 1 12l.008-.516C1.177 6.162 4.008 1 12 1z"
            fill="currentColor"
        />
        <path
            d="M12.482 5.01c4.719.202 6.409 3.384 6.513 6.662L19 12h-1.8c0-1.483-.374-2.772-1.114-3.66C15.394 7.51 14.192 6.8 12 6.8s-3.394.71-4.086 1.54C7.174 9.228 6.8 10.517 6.8 12s.374 2.772 1.114 3.66c.327.393.77.756 1.376 1.032l-.903 1.566C5.91 17.046 5 14.524 5 12l.005-.328C5.113 8.285 6.915 5 12 5z"
            fill="currentColor"
        />
    </svg>
));
ClickmeSolidSize24Glyph.displayName = 'ClickmeSolidSize24Glyph';
